import React from "react";

interface ActualSizeIconProps {
  className?: string;
}

const ActualSizeIcon: React.FC<ActualSizeIconProps> = ({
  className = "w-4 h-4",
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <mask
      id="mask0_2331_3578"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="2"
      width="20"
      height="20"
    >
      <rect x="2" y="2" width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_2331_3578)">
      <path
        d="M13.8749 15.9583H17.6249V12.2083H16.3749V14.7083H13.8749V15.9583ZM6.37492 11.7917H7.62492V9.29167H10.1249V8.04167H6.37492V11.7917ZM5.58971 18.25C5.16874 18.25 4.81242 18.1042 4.52075 17.8125C4.22909 17.5208 4.08325 17.1645 4.08325 16.7435V7.25646C4.08325 6.83549 4.22909 6.47917 4.52075 6.1875C4.81242 5.89583 5.16874 5.75 5.58971 5.75H18.4101C18.8311 5.75 19.1874 5.89583 19.4791 6.1875C19.7708 6.47917 19.9166 6.83549 19.9166 7.25646V16.7435C19.9166 17.1645 19.7708 17.5208 19.4791 17.8125C19.1874 18.1042 18.8311 18.25 18.4101 18.25H5.58971ZM5.58971 17H18.4101C18.4743 17 18.533 16.9733 18.5864 16.9198C18.6398 16.8665 18.6666 16.8077 18.6666 16.7435V7.25646C18.6666 7.19229 18.6398 7.13354 18.5864 7.08021C18.533 7.02674 18.4743 7 18.4101 7H5.58971C5.52554 7 5.46679 7.02674 5.41346 7.08021C5.35999 7.13354 5.33325 7.19229 5.33325 7.25646V16.7435C5.33325 16.8077 5.35999 16.8665 5.41346 16.9198C5.46679 16.9733 5.52554 17 5.58971 17Z"
        fill="#1C1B1F"
      />
    </g>
  </svg>
);

export default ActualSizeIcon;
